// extracted by mini-css-extract-plugin
export default {"svg":"Loading_svg__+wKwA","rotate4":"Loading_rotate4__M8l1A","circle":"Loading_circle__hrzZo","dash4":"Loading_dash4__XdD+k"};